"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonBreadCrumb = void 0;
const React = require("react");
const BronsonBreadCrumb = (props) => {
    const one = 1;
    return (React.createElement("nav", { "aria-label": 'Breadcrumb' },
        React.createElement("ul", { className: 'c-breadcrumb' }, props.directories.map((directory, index) => (React.createElement("li", { key: index, className: 'c-breadcrumb__item' },
            React.createElement("a", { id: `breadcrumb__item-${index}`, onClick: () => props.directoryClick(directory), className: `c-breadcrumb__link ${index < props.directories.length - one
                    ? ''
                    : 'is-current  is-disabled'}` },
                React.createElement("span", { className: 'c-breadcrumb__label' }, directory))))))));
};
exports.BronsonBreadCrumb = BronsonBreadCrumb;
